var app = angular.module("leonardo");

var GroupListActions = function($scope, ngDialog) {
  $scope.addGroup = function() {
    ngDialog.open({
      controller: 'GroupEditDialog',
      templateUrl: 'views/templates/dialog/admin/fields/group.html',
      data: {
        group: null
      }
    });
  };
};

app.controller('GroupListActions', ['$scope', 'ngDialog', GroupListActions]);
